import { useState, useEffect } from 'react';

export function useXProps() {
  const [xprops, setXProps] = useState(window.xprops);

  useEffect(() => {
    window.xpropsOnProps = props => {
      setXProps({ ...props });
    };
  }, []);

  return xprops;
}
